import { useOverviewFeeds } from '@/hooks/useOverviewFeeds'
import { useUI } from '@/store/ui'
import { Card } from '@diwata/ironvale'
import { ProjectsTile } from '@/components/tiles/ProjectsTile'
import { DeploysTile } from '@/components/tiles/DeploysTile'
import { HealthTile } from '@/components/tiles/HealthTile'
import { OpsTile } from '@/components/tiles/OpsTile'
import { ClientsTile } from '@/components/tiles/ClientsTile'
import { LakeTile } from '@/components/tiles/LakeTile'
import { LogTile } from '@/components/tiles/LogTile'
import { DocsTile } from '@/components/tiles/DocsTile'
import './board.css'

/**
 * The studio overview — a watch-only tile board over the daemon's machine-first
 * feeds (`GET /overview/feeds`). Tiles render readings and deep-link into the
 * owning surface; nothing here performs actions. The same JSON feeds agent
 * reasoning (daemon_brief / MCP), so what you see is what the familiar sees.
 */
export function Dashboard() {
  const { daemonUrl } = useUI()
  const { data, isLoading, error } = useOverviewFeeds({ refetchInterval: 60_000 })
  const feeds = data?.feeds

  return (
    <div>
      <div className="ap-page-header">
        <div>
          <div className="ap-page-title">Studio overview</div>
          {data && (
            <div className="ap-page-subtitle">
              watch-only · {new Date(data.generated_at).toLocaleTimeString()}
            </div>
          )}
        </div>
      </div>

      {isLoading && <p className="ap-empty">Loading…</p>}
      {error && (
        <Card>
          <p style={{ color: 'var(--ae-color-feedback-error)', fontSize: 13 }}>
            Could not reach DAEMON at {daemonUrl}. Check that DAEMON is running and the URL is
            correct in Settings.
          </p>
        </Card>
      )}

      {feeds && (
        <div className="ap-board">
          {feeds.projects && <ProjectsTile feed={feeds.projects} />}
          {feeds.deploys && <DeploysTile feed={feeds.deploys} />}
          {feeds.health && <HealthTile feed={feeds.health} />}
          {feeds.ops && <OpsTile feed={feeds.ops} />}
          {feeds.clients && <ClientsTile feed={feeds.clients} />}
          {feeds.lake && <LakeTile feed={feeds.lake} />}
          {feeds.log && <LogTile feed={feeds.log} />}
          {feeds.docs && <DocsTile feed={feeds.docs} />}
        </div>
      )}
    </div>
  )
}
